import {
  PROFILE_FETCH_PENDING,
  PROFILE_FETCH_SUCCESS,
  PROFILE_FETCH_FAIL,
  PROFILE_UPDATE_PENDING,
  PROFILE_UPDATE_SUCCESS,
  PROFILE_UPDATE_FAIL,
  PHOTO_UPDATE_PENDING,
  PHOTO_UPDATE_SUCCESS,
  PHOTO_UPDATE_FAIL,
  PASSWORD_UPDATE_PENDING,
  PASSWORD_UPDATE_SUCCESS,
  PASSWORD_UPDATE_FAIL,
  CLEAR_PROFILE_ERROR,
} from '../actions/index'

const initialState = {
  email: null,
  firstName: null,
  lastName: null,
  nickname: null,
  error: '',
  loading: false,
  password: null,
  newPassword: null,
  photo: null,
  photoUrl: null,
  accessToken: null,
}

export default function profile(state = initialState, action) {
  switch (action.type) {
    case PROFILE_FETCH_PENDING: {
      return {
        ...state,
        email: null,
        firstName: null,
        lastName: null,
        nickname: null,
        error: '',
        loading: true,
      }
    }

    case PROFILE_FETCH_SUCCESS: {
      const { data } = action.payload

      return {
        ...state,
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        nickname: data.nickname,
        photoUrl: data.photoUrl,
        error: '',
        loading: false,
        accessToken: data.accessToken
      }
    }

    case PROFILE_FETCH_FAIL: {
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    }

    case PROFILE_UPDATE_PENDING: {
      return {
        ...state,
        email: null,
        firstName: null,
        lastName: null,
        nickname: null,
        error: '',
        loading: true,
      }
    }

    case PROFILE_UPDATE_SUCCESS: {
      const { email, firstName, lastName, nickname } = JSON.parse(action.payload.config.data)

      return {
        ...state,
        email: email,
        firstName: firstName,
        lastName: lastName,
        nickname: nickname,
        error: '',
        loading: false,
      }
    }

    case PROFILE_UPDATE_FAIL: {
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    }

    case PHOTO_UPDATE_PENDING: {
      return {
        ...state,
        photo: action.payload.photo,
      }
    }

    case PHOTO_UPDATE_SUCCESS: {
      const { photo } = JSON.parse(action.payload.config.data)

      return {
        ...state,
        photo,
      }
    }

    case PHOTO_UPDATE_FAIL: {
      return {
        ...state,
        error: action.payload,
      }
    }

    case PASSWORD_UPDATE_PENDING: {
      return {
        ...state,
        password: null,
        newPassword: null,
        error: '',
        loading: true,
      }
    }

    case PASSWORD_UPDATE_SUCCESS: {
      return {
        ...state,
        password: action.payload.currentPassword,
        newPassword: action.payload.newPassword,
        error: '',
        loading: false,
        updated: true,
      }
    }

    case PASSWORD_UPDATE_FAIL: {
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    }

    case CLEAR_PROFILE_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/profile.js